import { Provider } from "react-redux";
// import BlogData from "../../data/tutorials.json";
import PageHead from "../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import Banner from "@/components/Common/Banner";
import BlogGrid from "@/components/Blogs/BlogGrid";
import BackToTop from "../backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import CPStaticContent from '../../models/CPStaticContent.js'
import Instagram from "@/components/Instagram/Instagram";
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge";

const BlogGridLayout = (post) => {

  const BlogData = {}
  BlogData['blogList'] = post.list
  // console.log(BlogData)

  // let getAllBlogs = JSON.parse(JSON.stringify(BlogData.tutorialsList));
  // let getAllBlogs = JSON.parse(JSON.stringify(BlogData.blogGrid));
  let getAllBlogs = BlogData.blogList

  return (
    <>
      <PageHead title="Tutorials" description="Collection of Tutorials created by CloudPedia authors" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <Banner col="col-lg-12" text="All Tutorials" listType="Tutorials" getBlog={getAllBlogs} />
          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <BlogGrid blogType={"tutorial"} blogData={getAllBlogs} isPagination={true} top={true} start={0} end={6} />
            </div>
          </div>

          <Instagram />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default BlogGridLayout;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("tutorials")
  await stContent.fetchContent()
  return await stContent.getListProps()
} 